export default import.meta.ROLLDOWN_FILE_URL_AI3mdqtvk84BhY7PMwLokA